import { Quadkey, XyoWorldAuction } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useEffect, useState } from 'react'

import useMinter from '../useMinter'
import { MinterAuctionContext } from './Context'

interface Props {
  enabled?: boolean
  quadkey: Quadkey
}

export const AuctionProvider: React.FC<PropsWithChildren<Props>> = (props) => {
  const { quadkey } = props
  const enabled = true
  const { minter } = useMinter()

  const [auction, setAuction] = useState<XyoWorldAuction>()
  const [refreshCount, setRefreshCount] = useState(0)

  useEffect(() => {
    if (minter && enabled) {
      const auction = minter.auctions().get(quadkey)
      setAuction(auction)
    }
  }, [quadkey, minter, refreshCount, enabled])

  const refresh = async () => {
    const currentAuction = auction
    setAuction(undefined)
    await currentAuction?.refresh()
    setAuction(currentAuction)
    setRefreshCount(refreshCount + 1)
  }

  const update = async () => {
    const currentAuction = auction
    setAuction(undefined)
    await currentAuction?.update()
    setAuction(currentAuction)
    setRefreshCount(refreshCount + 1)
  }

  return (
    <MinterAuctionContext.Provider
      value={{
        auction,
        quadkey,
        refresh,
        update,
      }}
    >
      {props.children}
    </MinterAuctionContext.Provider>
  )
}
